import React from 'react';
interface CTAButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
  ariaLabel?: string;
}
export function CTAButton({
  children,
  onClick,
  className = '',
  ariaLabel
}: CTAButtonProps) {
  return <button type="button" onClick={onClick} aria-label={ariaLabel} className={`inline-flex items-center justify-center rounded-2xl bg-brand-green px-7 py-4 font-display text-sm font-black tracking-wide text-white shadow-[0_8px_0_#14503a] transition duration-200 hover:-translate-y-0.5 hover:bg-brand-greenBright hover:shadow-[0_10px_0_#14503a] focus-visible:outline focus-visible:outline-4 focus-visible:outline-offset-4 focus-visible:outline-brand-greenBright active:translate-y-1 active:shadow-[0_3px_0_#14503a] ${className}`} data-id="element-42" data-mp="2kzg2xmsu1al3">
      {children}
    </button>;
}